(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ms-dimension-picker"] && !Shopify.designMode) return;
  try {
    const MSBB_CM2_PER_M2 = 10000;
  /** Volume des vidéos quand le visiteur active le son : bas, pour ne gêner personne. */
  const MSBB_VIDEO_VOLUME = 0.25;
  const MSBB_DEF_GOOD = 150;
  const MSBB_DEF_MIN = 100;
  const MSBB_CM_PER_INCH = 2.54;

  /**
   * Bloc d'achat unifié Maison Soubise.
   * Pilote le champ quantity et le champ id du formulaire produit du thème,
   * puis prend la main sur la soumission pour pouvoir ajouter plusieurs lignes.
   */
  class MsBuybox extends HTMLElement {
    #form = null;
    #atc = null;
    #atcBtn = null;
    #atcLabels = [];
    /**
     * Vrai dès que la cliente a touché une cote. Avant, la fiche affiche le
     * prix au m² et le « à partir de » : arriver sur 792 € pour un mur que
     * l'on n'a pas encore mesuré fait fuir. Le total ne s'affiche qu'une
     * fois que ce sont SES dimensions.
     */
    #touched = false;
    #qtyInput = null;
    #idInputs = [];
    #liveTimer = 0;
    #geo = null;
    #imgX = 0;
    #imgY = 0;
    #userMoved = false;
    #exactDims = null;
    #controller = new AbortController();

    connectedCallback() {
      if (this.dataset.msReady) return;
      this.dataset.msReady = '1';

      this.#form = this.closest('form');
      this.unitPriceEl = this.querySelector('[data-ms-unit-price]');
      this.wInput = this.querySelector('[data-ms-w]');
      this.hInput = this.querySelector('[data-ms-h]');
      this.recap = this.querySelector('[data-ms-recap]');
      this.sticky = this.querySelector('[data-ms-sticky]');
      this.live = this.querySelector('[data-ms-live]');
      this.ctaSlot = this.querySelector('[data-ms-cta-slot]');
      this.cfgOpen = this.querySelector('[data-ms-cfg-open]');

      this.unitEl = this.querySelector('[data-ms-unit]');
      this.unitPrefixEl = this.querySelector('[data-ms-unit-prefix]');
      this.fromEl = this.querySelector('[data-ms-from]');
      this.breakdownEl = this.querySelector('[data-ms-breakdown]');
      this.priceNoteEl = this.querySelector('[data-ms-price-note]');
      this.splitEl = this.querySelector('[data-ms-split]');
      this.tooHighEl = this.querySelector('[data-ms-toohigh]');

      this.basePrice = parseInt(this.dataset.basePrice, 10) || 0;
      this.minPrice = parseInt(this.dataset.minPrice, 10) || this.basePrice;
      this.minCm = parseInt(this.dataset.minCm, 10) || 40;
      this.minW = parseInt(this.dataset.minW, 10) || 10;
      this.minH = parseInt(this.dataset.minH, 10) || 50;
      this.maxH = parseInt(this.dataset.maxH, 10) || 610;
      this.enforceLimits = this.dataset.enforceLimits === 'true';
      this.laize = parseInt(this.dataset.laize, 10) || 53;
      this.wallW = parseInt(this.dataset.wallW, 10) || 1000;
      this.wallH = parseInt(this.dataset.wallH, 10) || 600;
      this.srcPxW = parseInt(this.dataset.srcPxW, 10) || 0;
      this.srcPxH = parseInt(this.dataset.srcPxH, 10) || 0;
      this.minDpi = parseInt(this.dataset.minDpi, 10) || 0;
      this.defEl = this.querySelector('[data-ms-def]');
      this.gluePrice = parseInt(this.dataset.gluePrice, 10) || 0;
      this.promoPct = parseFloat(this.dataset.promoPct ?? '') || 0;
      this.promoEnd = parseInt(this.dataset.promoEnd ?? '', 10) || 0;

      this.#adoptThemeButton();
      this.#bind();
      this.#syncSupport();
      this.calc();
      this.#watchSticky();
    }

    disconnectedCallback() {
      this.#controller.abort();
      clearTimeout(this.#liveTimer);
    }

    /* ─── Formatage ─── */

    #money(cents) {
      const digits = Math.round(cents) % 100 === 0 ? 0 : 2;
      return (cents / 100).toLocaleString('fr-FR', {
        style: 'currency', currency: 'EUR',
        minimumFractionDigits: digits, maximumFractionDigits: digits,
      });
    }

    #area(m2) {
      return `${m2.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m²`;
    }

    /** Promotion en cours (Réglages du thème > Promotion) : son %, ou 0 une fois la date de fin passée. */
    #pct() {
      return this.promoPct > 0 && Date.now() < this.promoEnd ? this.promoPct : 0;
    }

    /** Prix remisé, arrondi à l'euro inférieur comme l'app « Maison Soubise Promo » au panier (443,30 € → 376 €). */
    #off(cents) {
      const pct = this.#pct();
      if (!pct) return cents;
      return Math.floor((Math.round(cents) * (100 - pct)) / 10000) * 100;
    }

    /**
     * Écrit un prix : pendant la promotion, le nouveau puis l'ancien barré.
     * Seule la part « décor » est remisée : colle, kit et pose restent au prix.
     * @param {Element|null} el
     * @param {number} cents prix d'origine, en centimes
     * @param {number} [decor] part remisable
     */
    #price(el, cents, decor = cents) {
      if (!el) return;
      const now = cents - decor + this.#off(decor);
      if (now === cents) {
        el.textContent = this.#money(cents);
        return;
      }
      el.innerHTML = `<span class="ms-promo-now ms-promo-new">${this.#money(now)}</span> <s class="ms-promo-was">${this.#money(cents)}</s><span class="ms-promo-base">${this.#money(cents)}</span>`;
    }

    /**
     * Le montant ne « compte » pas : il se repose, une fois, quand il change.
     * 260 ms, assez pour que l'œil le retrouve, trop peu pour être remarqué.
     * Coupé si la personne a demandé moins de mouvement.
     * @param {HTMLElement} el
     */
    #settle(el) {
      if (!el?.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      el.animate(
        [{ opacity: 0.35, transform: 'translateY(5px)' }, { opacity: 1, transform: 'none' }],
        { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
    }

    /* ─── Bouton du thème ─── */

    /**
     * Déplace le bouton d'ajout au panier du thème dans l'emplacement du bloc.
     * Il reste à l'intérieur du <form>, donc la soumission native continue de marcher.
     */
    #adoptThemeButton() {
      if (!this.#form || !this.ctaSlot) return;

      this.#atc = this.#form.querySelector('[data-ref="add-to-cart-button-container"]');
      if (this.#atc) this.ctaSlot.appendChild(this.#atc);

      this.#atcBtn = this.#atc?.querySelector('[data-ref="add-to-cart-button"]') ?? null;
      this.#atcLabels = this.#atc
        ? [...this.#atc.querySelectorAll('.full-add-to-cart-text, .small-add-to-cart-text')]
        : [];

      this.#qtyInput = this.#form.querySelector('input[name="quantity"]');
      if (!this.#qtyInput) {
        this.#qtyInput = document.createElement('input');
        this.#qtyInput.type = 'hidden';
        this.#qtyInput.name = 'quantity';
        this.#qtyInput.value = '1';
        this.#form.appendChild(this.#qtyInput);
      }
      this.#idInputs = [...this.#form.querySelectorAll('input[name="id"]')];
    }

    #setCtaLabel(text) {
      for (const el of this.#atcLabels) el.textContent = text;
    }

    /**
     * Deux degrés, et la distinction compte.
     *
     * « incomplet » : il manque une cote. Le bouton reste ACTIF et renvoie au
     * champ à remplir — un CTA grisé au premier écran coûte plus qu'il ne
     * protège, il ressemble à une panne.
     *
     * « bloqué » : la définition est insuffisante, ou la hauteur dépasse le
     * décor. Là le bouton se ferme vraiment. C'est le seul cas : accepter
     * coûterait un mur flou, un retour, et une cliente qui raconte le rendu.
     *
     * @param {boolean} locked cotes manquantes
     * @param {boolean} [blocked] refus technique
     */
    #lockCta(locked, blocked = false) {
      this.incomplete = locked;
      this.blocked = blocked;
      if (this.#atcBtn) this.#atcBtn.disabled = blocked;
      this.classList.toggle('msbb--blocked', blocked);
    }

    /* ─── Écoutes ─── */

    #bind() {
      const { signal } = this.#controller;

      this.querySelector('[data-ms-margin]')?.addEventListener('change', () => this.calc(), { signal: this.#controller.signal });
      for (const type of ['pointerenter', 'touchstart', 'focusin']) {
        this.ctaSlot?.addEventListener(type, () => { if (this.dataset.exactEndpoint) this.#prefetch(); }, { passive: true, signal: this.#controller.signal });
      }
      for (const input of [this.wInput, this.hInput]) {
        input?.addEventListener('input', () => { this.#touched = true; this.calc(); }, { signal });
        input?.addEventListener('blur', () => this.calc(), { signal });
      }

      for (const radio of this.querySelectorAll('[data-ms-support]')) {
        radio.addEventListener('change', () => { this.#syncSupport(); this.calc(); }, { signal });
      }

      this.querySelector('[data-ms-glue]')?.addEventListener('change', () => this.calc(), { signal });
      this.addEventListener('ms-kit:change', () => this.calc(), { signal });
      this.querySelector('[data-ms-install]')?.addEventListener('change', () => this.calc(), { signal });
      if (!window.MsPose) window.addEventListener('DOMContentLoaded', () => this.calc(), { signal, once: true });

      this.querySelector('[data-ms-sample-add]')
        ?.addEventListener('click', (e) => this.#addSample(e.currentTarget), { signal });
      for (const input of this.querySelectorAll('[data-ms-sample-format]')) {
        input.addEventListener('change', () => this.#showSampleFormat(), { signal });
      }
      const sampleSupports = this.querySelectorAll('[data-ms-sample-support]');
      if (sampleSupports.length && !this.querySelector('[data-ms-sample-support]:checked')) sampleSupports[0].checked = true;
      const echThumb = this.querySelector('[data-ms-ech-thumb]');
      const showThumb = () => {
        const url = this.querySelector('[data-ms-sample-support]:checked')?.dataset.thumb;
        if (echThumb && url && echThumb.getAttribute('src') !== url) echThumb.src = url;
      };
      for (const input of sampleSupports) input.addEventListener('change', showThumb, { signal });
      showThumb();

      this.querySelector('[data-ms-sticky-cta]')
        ?.addEventListener('click', () => this.#stickyAction(), { signal });

      this.#form?.addEventListener('submit', (e) => this.#onSubmit(e), { signal, capture: true });

      window.addEventListener('resize', () => this.#drawPreview(), { signal });

      const stageImg = this.querySelector('.msbb__stage-img');
      if (stageImg && !(stageImg.complete && stageImg.naturalWidth > 0)) {
        stageImg.addEventListener('load', () => this.calc(), { once: true, signal });
      }
      const stage = this.querySelector('[data-ms-stage]');
      if (stage && 'ResizeObserver' in window) {
        let seen = '';
        const ro = new ResizeObserver(() => {
          const key = `${stage.clientWidth}x${stage.clientHeight}`;
          if (key === seen || !stage.clientWidth) return;
          seen = key;
          this.calc();
        });
        ro.observe(stage);
        signal.addEventListener('abort', () => ro.disconnect());
      }

      this.#bindDrag();
    }

    /** Le support choisi pilote le prix au m², la variante commandée et le kit de colle. */
    #syncSupport() {
      const picked = this.querySelector('[data-ms-support]:checked');
      if (!picked) return;

      this.basePrice = parseInt(picked.dataset.price, 10) || this.basePrice;
      this.laize = parseInt(picked.dataset.laize, 10) || this.laize;
      this.#setVariant(picked.value);

      const propSupport = this.querySelector('[data-ms-prop-support]');
      if (propSupport) propSupport.value = picked.dataset.name || '';

      document.dispatchEvent(new CustomEvent('ms:support-change', {
        bubbles: true,
        detail: {
          id: picked.value,
          name: picked.dataset.name || '',
          badge: picked.dataset.badge || '',
          laize: this.laize,
          price: this.basePrice,
        },
      }));

      const supportName = (picked.dataset.name || '').toLowerCase();
      for (const vow of this.querySelectorAll('[data-ms-vow-only]')) {
        vow.hidden = !supportName.includes(vow.dataset.msVowOnly);
      }

      const glueAllowed = picked.dataset.glueAllowed === '1';
      const glueRow = this.querySelector('[data-ms-glue-row]');
      const glueInput = this.querySelector('[data-ms-glue]');
      const glueNote = this.querySelector('[data-ms-glue-note]');
      if (glueRow) glueRow.hidden = !glueAllowed;
      if (!glueAllowed && glueInput) glueInput.checked = false;
      if (glueNote) glueNote.hidden = glueAllowed;
      const kit = this.querySelector('ms-pose-kit');
      if (kit) {
        kit.hidden = !glueAllowed;
        if (!glueAllowed) kit.clear?.();
      }

      this.#setText('[data-ms-sticky-mode]', picked.dataset.name || '');
      this.#setText('[data-ms-cfg-support]', `${picked.dataset.name || ''} · ${this.#money(this.#off(this.basePrice))} / ${this.dataset.unit || 'm²'}`);
    }

    #setVariant(id) {
      if (!id) return;
      for (const input of this.#idInputs) input.value = id;
    }

    get #glueOn() {
      const row = this.querySelector('[data-ms-glue-row]');
      const input = this.querySelector('[data-ms-glue]');
      return Boolean(input?.checked && row && !row.hidden);
    }

    get #installOn() {
      const card = this.querySelector('[data-ms-pose-card]');
      return Boolean(card && !card.hidden && this.querySelector('[data-ms-install]')?.checked);
    }

    /* ─── Calcul ─── */

    calc() {
      this.#setVariant(this.querySelector('[data-ms-support]:checked')?.value);

      const w = parseFloat(this.wInput?.value ?? '');
      const h = parseFloat(this.hInput?.value ?? '');
      const valid = Number.isFinite(w) && Number.isFinite(h) && w >= this.minW && h >= this.minH;

      if (!valid) return this.#renderEmpty();
      this.classList.remove('msbb--idle');

      if (this.enforceLimits && h > this.maxH) return this.#renderTooHigh(h);
      this.#hideTooHigh();

      const marginBox = this.querySelector('[data-ms-margin]');
      const add = marginBox?.checked ? (parseFloat(this.dataset.marginCm) || 0) : 0;
      const wOrder = w + add;
      const hOrder = h + add;
      const wCm = this.enforceLimits ? Math.min(wOrder, this.wallW) : wOrder;
      const hCm = this.enforceLimits ? Math.min(hOrder, this.wallH) : hOrder;
      const marginOut = this.querySelector('[data-ms-margin-out]');
      if (marginOut) {
        marginOut.hidden = add <= 0;
        marginOut.textContent = add > 0 ? `Imprimé en ${Math.round(wCm)} × ${Math.round(hCm)} cm` : '';
      }
      this.#setProp('[data-ms-prop-wall]', add > 0 ? `${Math.round(w)} × ${Math.round(h)} cm, + ${add / 2} cm de marge de chaque côté` : `${Math.round(w)} × ${Math.round(h)} cm, sans marge`);

      this.#drawPreview(wCm, hCm);

      const etat = this.#renderDefinition(this.#dpi(wCm, hCm), wCm, hCm);
      if (etat === 'refus') return this.#renderTooBig(wCm, hCm);

      const m2 = (wCm * hCm) / MSBB_CM2_PER_M2;
      const billed = Math.max(1, this.dataset.billing === 'nearest' ? Math.round(m2) : Math.ceil(m2));
      const exact = Boolean(this.dataset.exactEndpoint);
      const wR = Math.round(wCm);
      const hR = Math.round(hCm);
      const m2Exact = Math.max(1, Math.round((wR * hR) / 100) / 100);
      this.#exactDims = exact ? { w: wR, h: hR, m2: m2Exact } : null;
      if (exact) this.#schedulePrefetch();
      const decorCents = exact ? Math.round(this.basePrice * m2Exact) : billed * this.basePrice;
      const pose = this.#renderPose(Math.ceil(m2));
      const kitCents = this.querySelector('ms-pose-kit')?.cents?.() ?? 0;
      const extras = (this.#glueOn ? this.gluePrice : 0) + (this.#installOn && pose?.state === 'ok' ? pose.price : 0) + kitCents;
      const total = decorCents + extras;
      // Montant réellement payé pendant la promotion : le décor remisé, le reste au prix.
      const paid = total - decorCents + this.#off(decorCents);

      this.#setText('[data-ms-recap-dims]', `${Math.round(wCm)} × ${Math.round(hCm)} cm`);
      this.#setText('[data-ms-recap-area]', this.#area(m2));
      this.#setText('[data-ms-recap-billed]', `${billed} m²`);
      this.#setText('[data-ms-recap-total]', this.#money(paid));

      const billedRow = this.querySelector('[data-ms-recap-billed-row]');
      if (billedRow) billedRow.hidden = exact || this.dataset.billedRow !== '1' || billed <= m2 + 0.0001;
      this.#setText('[data-ms-zoom-dims]', `${Math.round(wCm)} × ${Math.round(hCm)} cm`);
      this.#setText('[data-ms-zoom-total]', this.#money(paid));

      if (this.#touched) this.#renderPriceTotal({ total, decor: decorCents, wCm, hCm, m2, billed });
      else this.#renderPriceUnit();
      this.classList.toggle('msbb--pristine', !this.#touched);

      const glueRecap = this.querySelector('[data-ms-recap-glue]');
      if (glueRecap) glueRecap.hidden = !this.#glueOn;
      const installRecap = this.querySelector('[data-ms-recap-install]');
      if (installRecap) installRecap.hidden = !this.#installOn;

      if (this.recap) this.recap.hidden = false;
      if (this.#qtyInput) this.#qtyInput.value = String(billed);

      this.#setProp('[data-ms-prop-w]', `${Math.round(wCm)} cm`);
      this.#setProp('[data-ms-prop-h]', `${Math.round(hCm)} cm`);
      this.#setProp('[data-ms-prop-surface]', exact ? `${m2Exact.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} m²` : `${billed} m²`);
      this.#setProp('[data-ms-prop-les]', `${this.#les(wCm)} lés de ${this.laize} cm`);
      this.#setProp('[data-ms-prop-unit]', `${this.#money(this.basePrice)} / ${this.dataset.unit || 'm²'}`);
      this.#setProp('[data-ms-prop-pose]', this.#installOn ? (this.dataset.poseProp || 'Demandée, devis confirmé sous 24 h') : '');

      if (this.#touched) {
        this.#setCtaLabel(`${this.dataset.ctaCustom || 'Commander mon décor'} · ${this.#money(paid)}`);
        this.#syncSticky(this.#money(paid), `${Math.round(wCm)} × ${Math.round(hCm)} cm · ${this.#area(m2)}`, this.#supportName());
      } else {
        this.#setCtaLabel(this.dataset.ctaCustom || 'Commander mon décor');
        this.#syncSticky(this.#stickyUnit(), this.dataset.stickySub || '', this.#supportName());
      }
      this.#setText('[data-ms-cfg-dims]', `${Math.round(w)} × ${Math.round(h)} cm${add > 0 ? ` · marge ${add / 2} cm` : ''} · ${this.#area(m2)}`);
      this.#price(this.querySelector('[data-ms-cfg-total]'), total, decorCents);
      if (this.cfgOpen) this.#setCtaLabel(this.dataset.cfgBuy || 'Ajouter au panier');
      this.#lockCta(false);
      this.#announce(`Mur de ${Math.round(wCm)} sur ${Math.round(hCm)} centimètres, ${this.#area(m2)}, facturé ${exact ? m2Exact.toLocaleString('fr-FR') : billed} mètres carrés. Total ${this.#money(paid)}.`);

      return undefined;
    }

    /**
     * Définition d'impression aux cotes demandées, en points par pouce.
     * Le motif couvre le cadre : c'est le côté le plus contraignant qui fixe
     * l'échelle, donc la finesse de ce qui sort de la machine.
     * @param {number} wCm
     * @param {number} hCm
     * @returns {number} 0 si la taille du fichier source est inconnue
     */
    #dpi(wCm, hCm) {
      if (!this.srcPxW || !this.srcPxH || wCm <= 0 || hCm <= 0) return 0;
      const pxCropW = this.srcPxW * this.#cropFractionW();
      const pxCropH = this.srcPxH * this.#cropFractionH();
      return Math.min(pxCropW / (wCm / MSBB_CM_PER_INCH), pxCropH / (hCm / MSBB_CM_PER_INCH));
    }

    /** Part de la hauteur du fichier source couverte par le cadre, entre 0 et 1. */
    #cropFractionH() {
      if (!this.#geo) return 1;
      const { fh, ih } = this.#geo;
      if (!ih) return 1;
      return Math.min(1, Math.max(0.02, fh / ih));
    }

    /**
     * Part de la largeur du fichier source couverte par le cadre, entre 0 et 1.
     * Avant le premier rendu de l'aperçu, le motif entier est retenu.
     * @returns {number}
     */
    #cropFractionW() {
      if (!this.#geo) return 1;
      const { fw, iw } = this.#geo;
      if (!iw) return 1;
      return Math.min(1, Math.max(0.02, fw / iw));
    }

    /**
     * Le côté qui bute, et jusqu'où il peut aller sans descendre sous le seuil.
     * @param {number} wCm
     * @param {number} hCm
     * @returns {object} le côté qui bute (cote) et sa valeur maximale (max)
     */
    #limite(wCm, hCm) {
      const pxCrop = this.srcPxW * this.#cropFractionW();
      const maxW = Math.floor((pxCrop * MSBB_CM_PER_INCH) / MSBB_DEF_MIN);
      const ratio = wCm > 0 && hCm > 0 ? hCm / wCm : 1;
      const maxH = Math.min(this.maxH, Math.floor(maxW * ratio));
      return { maxW, maxH };
    }

    /**
     * Verdict de définition, en trois états. On n'affiche PAS le nombre de
     * dpi : « 187 dpi » ne veut rien dire pour qui achète un mur, et un
     * chiffre qu'on ne sait pas lire inquiète au lieu de rassurer.
     * @param {number} dpi
     * @param {number} wCm
     * @param {number} hCm
     * @returns {string} 'ok' | 'juste' | 'refus' | '' si la source est inconnue
     */
    #renderDefinition(dpi, wCm, hCm) {
      if (!this.defEl) return '';
      if (!dpi) {
        this.defEl.hidden = true;
        return '';
      }

      let etat = 'ok';
      let texte = this.dataset.defOk || 'Définition optimale à ces dimensions';

      if (dpi < MSBB_DEF_MIN && !this.enforceLimits) {
        this.defEl.hidden = true;
        return '';
      }

      if (dpi < MSBB_DEF_MIN) {
        const l = this.#limite(wCm, hCm);
        etat = 'refus';
        texte = this.#fill(this.dataset.defRefus, { max_w: l.maxW, max_h: l.maxH });
      } else if (dpi < MSBB_DEF_GOOD) {
        etat = 'juste';
        texte = this.dataset.defJuste || 'Définition correcte, net à 50 cm';
      }

      this.defEl.dataset.etat = etat;
      this.#setText('[data-ms-def-text]', texte);
      this.defEl.hidden = false;
      return etat;
    }

    /**
     * Cotes au-delà de ce que le fichier peut donner. On le dit, on montre
     * jusqu'où on va, et on ne prend pas la commande.
     * @param {number} wCm
     * @param {number} hCm
     */
    #renderTooBig(wCm, hCm) {
      const l = this.#limite(wCm, hCm);
      this.#renderPriceUnit();
      if (this.recap) this.recap.hidden = true;
      if (this.#qtyInput) this.#qtyInput.value = '1';
      this.#clearProps();
      this.#setCtaLabel(this.dataset.ctaTooBig || 'Ces dimensions dépassent ce décor');
      this.#lockCta(true, true);
      this.#syncSticky(
        this.dataset.ctaTooBig || '',
        `Jusqu'à ${l.maxW} × ${l.maxH} cm`,
        this.#supportName()
      );
      this.#drawPreview(wCm, hCm);
      this.#announce(`Définition insuffisante à ces dimensions. Ce décor tient jusqu'à ${l.maxW} centimètres de large sur ${l.maxH} de haut.`);
      return undefined;
    }

    /* ─── Tête de bloc : prix au m², puis prix du mur ─── */

    /**
     * Nombre de lés livrés, depuis la largeur du mur et la laize du support.
     * @param {number} wCm
     * @returns {number}
     */
    #les(wCm) {
      if (!this.laize || wCm <= 0) return 0;
      return Math.max(1, Math.ceil(wCm / this.laize));
    }

    /**
     * Remplit un gabarit de texte : les libellés restent modifiables dans
     * l'éditeur de thème, le JS ne fait qu'y injecter les valeurs.
     * @param {string} template
     * @param {object} values
     * @returns {string}
     */
    #fill(template, values) {
      if (!template) return '';
      return template.replace(/\{(\w+)\}/g, (match, key) =>
        Object.hasOwn(values, key) ? String(values[key]) : match);
    }

    /** État de départ : prix au m² et prix de départ du décor. */
    #renderPriceUnit() {
      this.#price(this.unitPriceEl, this.minPrice);
      if (this.unitPrefixEl) this.unitPrefixEl.hidden = false;
      if (this.unitEl) this.unitEl.hidden = false;
      const fromM2 = parseFloat(this.dataset.fromM2 ?? '');
      const fromAmount = this.querySelector('[data-ms-from-amount]');
      if (fromAmount && Number.isFinite(fromM2) && fromM2 > 0) {
        this.#price(fromAmount, this.minPrice * fromM2);
      }
      if (this.fromEl) this.fromEl.hidden = !(Number.isFinite(fromM2) && fromM2 > 0);
      if (this.breakdownEl) this.breakdownEl.hidden = true;
      if (this.priceNoteEl) this.priceNoteEl.textContent = this.dataset.priceNote || '';
      this.classList.remove('msbb--priced');
      if (Number.isFinite(fromM2) && fromM2 > 0) this.#renderSplit(this.#off(this.minPrice * fromM2));
      else if (this.splitEl) this.splitEl.hidden = !this.cfgOpen;
    }

    /** Texte de la barre collante avant les cotes : le même prix d'entrée que la tête. */
    #stickyUnit() {
      const prefix = this.dataset.unitPrefix ? `${this.dataset.unitPrefix} ` : '';
      return `${prefix}${this.#money(this.#off(this.minPrice))} / ${this.dataset.unit || 'm²'}`;
    }

    /**
     * Paiement fractionné : le montant d'une échéance suit le prix affiché au
     * même instant (prix de départ, puis total du mur). Hors des bornes
     * acceptées par Klarna, la ligne se retire plutôt que d'annoncer un
     * paiement qui sera refusé à la caisse.
     * @param {number} cents montant à fractionner
     */
    #renderSplit(cents) {
      if (!this.splitEl) return;
      const min = parseInt(this.splitEl.dataset.splitMin, 10) || 0;
      const max = parseInt(this.splitEl.dataset.splitMax, 10) || 0;
      const outOfRange = !(cents > 0) || cents < min || (max > 0 && cents > max);
      this.splitEl.hidden = outOfRange;
      if (outOfRange) return;
      const n = parseInt(this.splitEl.dataset.splitN, 10) || 3;
      this.#setText('[data-ms-split-amount]', this.#money(Math.ceil(cents / n)));
    }

    /**
     * Cotes saisies : le prix du mur passe devant, le détail au m² reste
     * lisible dessous. Le m² permet la comparaison, le prix du mur permet la
     * décision — il faut les deux, sur la même ligne.
     * @param {object} data
     */
    #renderPriceTotal({ total, decor = total, wCm, hCm, m2, billed }) {
      const paid = total - decor + this.#off(decor);
      const unit = this.dataset.unit || 'm²';
      const values = {
        largeur: Math.round(wCm),
        hauteur: Math.round(hCm),
        surface: m2.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        facturee: billed,
        prix_unitaire: this.#money(this.basePrice),
        unite: unit,
        les: this.#les(wCm),
        laize: this.laize,
      };

      if (this.dataset.headTotal !== '1') {
        if (this.fromEl) this.fromEl.hidden = true;
        if (this.breakdownEl) this.breakdownEl.hidden = true;
        if (this.priceNoteEl) this.priceNoteEl.textContent = this.#fill(this.dataset.lesTemplate, values);
        this.#renderSplit(paid);
        return;
      }
      if (this.unitPriceEl) {
        const prev = this.unitPriceEl.textContent;
        this.#price(this.unitPriceEl, total, decor);
        if (this.unitPriceEl.textContent !== prev) this.#settle(this.unitPriceEl);
      }
      if (this.unitPrefixEl) this.unitPrefixEl.hidden = true;
      if (this.unitEl) this.unitEl.hidden = true;
      if (this.fromEl) this.fromEl.hidden = true;
      if (this.breakdownEl) {
        this.breakdownEl.textContent = this.#fill(this.dataset.breakdownTemplate, values);
        this.breakdownEl.hidden = false;
      }
      if (this.priceNoteEl) {
        this.priceNoteEl.textContent = this.#fill(this.dataset.lesTemplate, values);
      }
      this.#renderSplit(paid);
      this.classList.add('msbb--priced');
    }

    /* ─── Hauteur au-delà de la limite du décor ─── */

    #hideTooHigh() {
      if (this.tooHighEl) this.tooHighEl.hidden = true;
    }

    /**
     * On refuse la commande, on annonce la limite de CE décor, et on en
     * propose un qui tient la hauteur demandée. Refuser une vente pour
     * protéger le rendu ne coûte rien et personne d'autre ne le fait.
     * @param {number} h hauteur demandée, en cm
     */
    #renderTooHigh(h) {
      const metres = (this.maxH / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const altMax = parseInt(this.dataset.altMaxH ?? '', 10);
      const texte = this.#fill(this.dataset.tooHighTemplate, {
        max_cm: this.maxH,
        max_m: metres,
        demande: Math.round(h),
        decor: this.dataset.altName || '',
        decor_max_m: Number.isFinite(altMax)
          ? (altMax / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : '',
      });

      this.#setText('[data-ms-toohigh-text]', texte);
      if (this.tooHighEl) this.tooHighEl.hidden = false;
      if (this.defEl) this.defEl.hidden = true;
      if (this.recap) this.recap.hidden = true;
      if (this.#qtyInput) this.#qtyInput.value = '1';
      this.#clearProps();
      this.#renderPriceUnit();
      this.#setCtaLabel(this.dataset.ctaTooHigh || this.dataset.ctaTooBig || 'Ces dimensions dépassent ce décor');
      this.#lockCta(true, true);
      this.#syncSticky(this.dataset.ctaTooHigh || '', 'Grandes hauteurs sur demande', this.#supportName());
      this.#announce(`Hauteur au-delà de ce décor. ${texte}`);
      return undefined;
    }

    #renderEmpty() {
      this.#hideTooHigh();
      this.#renderPriceUnit();
      if (this.defEl) this.defEl.hidden = true;
      if (this.recap) this.recap.hidden = true;
      if (this.#qtyInput) this.#qtyInput.value = '1';
      this.#clearProps();
      this.#setCtaLabel(this.dataset.ctaPrompt || 'Entrez vos dimensions');
      this.#lockCta(true);
      this.#syncSticky(this.#stickyUnit(), this.dataset.stickySub || '', this.#supportName());
      this.#setText('[data-ms-cfg-dims]', this.dataset.cfgDimsEmpty || 'À renseigner');
      this.#setText('[data-ms-cfg-total]', '');
      const preview = this.querySelector('[data-ms-preview]');
      const defW = parseFloat(this.dataset.defW ?? '');
      const defH = parseFloat(this.dataset.defH ?? '');
      if (preview && defW > 0 && defH > 0) {
        this.classList.add('msbb--idle');
        const art = this.querySelector('.msbb__stage-img');
        const artW = parseFloat(art?.getAttribute('width') ?? '');
        const artH = parseFloat(art?.getAttribute('height') ?? '');
        if (artW > 0 && artH > 0) this.#drawPreview(artW, artH); else this.#drawPreview(defW, defH);
      } else if (preview) {
        preview.hidden = true;
      }
    }

    #setText(selector, value) {
      const el = this.querySelector(selector);
      if (el) el.textContent = value;
    }

    /** Une propriété de ligne vide ne doit pas partir au panier : on la désactive. */
    #setProp(selector, value) {
      const el = this.querySelector(selector);
      if (!el) return;
      el.value = value;
      el.disabled = !value;
    }

    #clearProps() {
      for (const sel of ['[data-ms-prop-wall]', '[data-ms-prop-w]', '[data-ms-prop-h]', '[data-ms-prop-surface]', '[data-ms-prop-pos]', '[data-ms-prop-les]', '[data-ms-prop-unit]', '[data-ms-prop-pose]']) {
        this.#setProp(sel, '');
      }
    }

    /** Annonce différée : sans délai, chaque frappe serait lue par le lecteur d'écran. */
    #announce(message) {
      if (!this.live) return;
      clearTimeout(this.#liveTimer);
      this.#liveTimer = setTimeout(() => { this.live.textContent = message; }, 700);
    }

    #syncSticky(amount, sub, mode) {
      this.#setText('[data-ms-sticky-amount]', amount);
      this.#setText('[data-ms-sticky-sub]', sub);
      if (mode) this.#setText('[data-ms-sticky-mode]', mode);
    }

    /** Nom du support choisi, tel qu'il partira au panier. */
    #supportName() {
      return this.querySelector('[data-ms-support]:checked')?.dataset.name ?? '';
    }

    /* ─── Aperçu du recadrage ─── */

    #drawPreview(wCm, hCm) {
      const preview = this.querySelector('[data-ms-preview]');
      const stage = this.querySelector('[data-ms-stage]');
      const frame = this.querySelector('[data-ms-frame]');
      if (!preview || !stage || !frame) return;

      const w = wCm ?? parseFloat(this.wInput?.value ?? '');
      const h = hCm ?? parseFloat(this.hInput?.value ?? '');
      if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) return;

      preview.hidden = false;
      const sw = stage.clientWidth;
      const sh = stage.clientHeight;
      if (!sw || !sh) return;

      const ratio = w / h;
      let fw = sw * 0.88;
      let fh = fw / ratio;
      if (fh > sh * 0.88) { fh = sh * 0.88; fw = fh * ratio; }

      const img = stage.querySelector('.msbb__stage-img');
      const attrW = parseFloat(img?.getAttribute('width') ?? '');
      const attrH = parseFloat(img?.getAttribute('height') ?? '');
      let natural = this.wallW / this.wallH;
      if (img?.naturalWidth > 0) natural = img.naturalWidth / img.naturalHeight;
      else if (attrW > 0 && attrH > 0) natural = attrW / attrH;
      let iw;
      let ih;
      if (fw / fh > natural) { iw = fw; ih = fw / natural; } else { ih = fh; iw = fh * natural; }

      const prev = this.#geo;
      this.#geo = { fw, fh, fx: (sw - fw) / 2, fy: (sh - fh) / 2, iw, ih, wCm: w };
      if (!this.#userMoved) {
        this.#imgX = (fw - iw) / 2;
        this.#imgY = (fh - ih) / 2;
      } else if (prev && prev.iw > 0 && prev.ih > 0) {
        const cx = (prev.fw / 2 - this.#imgX) / prev.iw;
        const cy = (prev.fh / 2 - this.#imgY) / prev.ih;
        this.#imgX = fw / 2 - cx * iw;
        this.#imgY = fh / 2 - cy * ih;
      }
      this.#clampImg();
      this.#applyGeo();

      this.#setText('[data-ms-lbl-w]', `${Math.round(w)} cm`);
      this.#setText('[data-ms-lbl-h]', `${Math.round(h)} cm`);
    }

    #clampImg() {
      if (!this.#geo) return;
      const { fw, fh, iw, ih } = this.#geo;
      this.#imgX = Math.min(0, Math.max(fw - iw, this.#imgX));
      this.#imgY = Math.min(0, Math.max(fh - ih, this.#imgY));
    }

    #applyGeo() {
      const frame = this.querySelector('[data-ms-frame]');
      const img = this.querySelector('.msbb__stage-img');
      if (!this.#geo || !frame) return;
      const { fx, fy, fw, fh, iw, ih } = this.#geo;

      frame.style.insetInlineStart = `${Math.round(fx)}px`;
      frame.style.insetBlockStart = `${Math.round(fy)}px`;
      frame.style.width = `${Math.round(fw)}px`;
      frame.style.height = `${Math.round(fh)}px`;
      if (this.#geo.wCm > 0 && this.laize > 0) frame.style.setProperty('--msbb-seam', `${(fw * this.laize) / this.#geo.wCm}px`);

      if (img) {
        img.style.width = `${Math.round(iw)}px`;
        img.style.height = `${Math.round(ih)}px`;
        img.style.insetInlineStart = `${Math.round(fx + this.#imgX)}px`;
        img.style.insetBlockStart = `${Math.round(fy + this.#imgY)}px`;
      }

      const front = this.querySelector('.msbb__frame-img');
      if (front) {
        front.style.width = `${Math.round(iw)}px`;
        front.style.height = `${Math.round(ih)}px`;
        front.style.insetInlineStart = `${Math.round(this.#imgX)}px`;
        front.style.insetBlockStart = `${Math.round(this.#imgY)}px`;
      }

      this.#writeCrop();
    }

    /** Fenêtre de découpe en % du fichier source : directement exploitable en production. */
    #writeCrop() {
      if (!this.#geo) return;
      const { fw, fh, iw, ih } = this.#geo;
      if (iw - fw < 1 && ih - fh < 1) {
        this.#setProp('[data-ms-prop-pos]', 'Motif entier (aucun recadrage)');
        return;
      }
      const pc = (v, t) => Math.max(0, Math.min(100, Math.round((v / t) * 1000) / 10));
      const x1 = pc(-this.#imgX, iw);
      const x2 = pc(-this.#imgX + fw, iw);
      const y1 = pc(-this.#imgY, ih);
      const y2 = pc(-this.#imgY + fh, ih);
      this.#setProp('[data-ms-prop-pos]', `X ${x1} → ${x2} % · Y ${y1} → ${y2} % du motif`);
    }

    /** Afficher les lés, et le cadrage en plein écran. */
    #bindStageTools() {
      const { signal } = this.#controller;
      const seamBtns = [...this.querySelectorAll('[data-ms-seams]')];
      for (const btn of seamBtns) {
        btn.addEventListener('click', () => {
          const on = !this.classList.contains('msbb--seams');
          this.classList.toggle('msbb--seams', on);
          for (const b of seamBtns) b.setAttribute('aria-pressed', String(on));
        }, { signal });
      }
      const rulerBtn = this.querySelector('[data-ms-ruler]');
      rulerBtn?.addEventListener('click', () => {
        const on = this.classList.toggle('msbb--noruler');
        rulerBtn.setAttribute('aria-pressed', String(!on));
      }, { signal });

      this.#bindVideos();

      const dialog = this.querySelector('[data-ms-zoom]');
      const stage = this.querySelector('[data-ms-stage]');
      const home = this.querySelector('[data-ms-stage-home]');
      const body = this.querySelector('[data-ms-zoom-body]');
      const opener = this.querySelector('[data-ms-zoom-open]');
      if (!dialog || !stage || !home || !body || typeof dialog.showModal !== 'function') {
        if (opener) opener.hidden = true;
        return;
      }
      let lastOpener = null;
      this.#openConfig = (from) => {
        if (dialog.open) return;
        lastOpener = from ?? this.cfgOpen ?? opener;
        body.appendChild(stage);
        stage.classList.add('msbb__stage--zoom');
        const wait = this.querySelector('[data-ms-wait]');
        if (wait && this.cfgOpen) dialog.appendChild(wait);
        dialog.showModal();
        document.documentElement.classList.add('ms-cfg-open');
        if (window.msScrollLock) window.msScrollLock(true);
        requestAnimationFrame(() => this.#drawPreview());
        if (this.cfgOpen && this.incomplete) this.#cfgShow('dims');
      };
      opener?.addEventListener('click', () => this.#openConfig(opener), { signal });
      this.cfgOpen?.addEventListener('click', () => this.#openConfig(this.cfgOpen), { signal });
      for (const btn of this.querySelectorAll('[data-ms-zoom-close]')) {
        btn.addEventListener('click', () => dialog.close(), { signal });
      }
      for (const btn of this.querySelectorAll('[data-ms-cfg-edit]')) {
        btn.addEventListener('click', () => this.#cfgShow(btn.dataset.msCfgEdit, true), { signal });
      }
      for (const btn of this.querySelectorAll('[data-ms-cfg-done], [data-ms-cfg-close]')) {
        btn.addEventListener('click', () => {
          const was = this.#cfgWhich;
          this.#cfgShow('');
          if (was) this.querySelector(`[data-ms-cfg-edit="${was}"]`)?.focus({ preventScroll: true });
        }, { signal });
      }
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ms-cfg-open');
        this.#cfgShow('');
        const wait = this.querySelector('[data-ms-wait]');
        if (wait && wait.parentElement === dialog) this.append(wait);
        stage.classList.remove('msbb__stage--zoom');
        home.after(stage);
        if (window.msScrollLock) window.msScrollLock(false);
        requestAnimationFrame(() => this.#drawPreview());
        lastOpener?.focus({ preventScroll: true });
      }, { signal });
    }

    /** Ouvre le configurateur ; remplacé au branchement s'il y a une fenêtre. */
    #openConfig = () => {};

    #cfgWhich = '';

    /**
     * Le panneau « Modifier » : il emprunte le bloc des cotes ou la liste des
     * supports à la fiche, puis les lui rend. Les écoutes restent attachées
     * aux mêmes champs, le calcul ne voit aucune différence.
     * @param {string} which 'dims', 'support' ou '' pour refermer
     * @param {boolean} [toggle] un second clic sur le même bouton referme
     */
    #cfgShow(which, toggle = false) {
      const panel = this.querySelector('[data-ms-cfg-panel]');
      const body = panel?.querySelector('[data-ms-cfg-panel-body]');
      if (!panel || !body) return;
      const next = toggle && which === this.#cfgWhich ? '' : which;

      for (const [blockSel, homeSel] of [['[data-ms-dims-block]', '[data-ms-dims-home]'], ['[data-ms-sup-block]', '[data-ms-sup-home]']]) {
        const el = this.querySelector(blockSel);
        const homeEl = this.querySelector(homeSel);
        if (el && homeEl && el.parentElement === body) homeEl.after(el);
      }

      this.#cfgWhich = next;
      const el = next ? this.querySelector(next === 'dims' ? '[data-ms-dims-block]' : '[data-ms-sup-block]') : null;
      if (el) body.appendChild(el);
      panel.hidden = !el;
      panel.dataset.which = next;
      const title = panel.querySelector('[data-ms-cfg-panel-title]');
      if (title && el) title.textContent = next === 'dims' ? panel.dataset.titleDims : panel.dataset.titleSupport;
      for (const btn of this.querySelectorAll('[data-ms-cfg-edit]')) {
        btn.setAttribute('aria-expanded', String(Boolean(el) && btn.dataset.msCfgEdit === next));
      }
      if (!el) return;
      const target = next === 'dims'
        ? (this.wInput?.value ? this.hInput : this.wInput) ?? this.wInput
        : el.querySelector('[data-ms-support]:checked') ?? el.querySelector('[data-ms-support]');
      target?.focus({ preventScroll: true });
      requestAnimationFrame(() => this.#drawPreview());
    }

    /** Les vidéos de la fiche : une fenêtre par vidéo, lue à l'ouverture, arrêtée à la fermeture. */
    #bindVideos() {
      const { signal } = this.#controller;
      for (const btn of this.querySelectorAll('[data-ms-vid-open]')) {
        const dialog = document.getElementById(btn.dataset.msVidOpen);
        if (!dialog || typeof dialog.showModal !== 'function') continue;
        const video = dialog.querySelector('video');
        const sound = dialog.querySelector('[data-ms-vid-sound]');
        const setSound = (on) => {
          if (!video) return;
          video.muted = !on;
          if (on) video.volume = MSBB_VIDEO_VOLUME;
          sound?.setAttribute('aria-pressed', String(on));
          sound?.setAttribute('aria-label', on ? 'Couper le son' : 'Activer le son');
        };
        if (video) {
          video.disablePictureInPicture = true;
          video.addEventListener('contextmenu', (e) => e.preventDefault(), { signal });
        }
        btn.addEventListener('click', () => {
          dialog.showModal();
          document.documentElement.classList.add('ms-cfg-open');
          setSound(false);
          video?.play?.().catch(() => {});
        }, { signal });
        sound?.addEventListener('click', () => setSound(video?.muted ?? false), { signal });
        video?.addEventListener('click', () => { if (video.paused) video.play().catch(() => {}); else video.pause(); }, { signal });
        dialog.querySelector('[data-ms-vid-close]')?.addEventListener('click', () => dialog.close(), { signal });
        dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); }, { signal });
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('ms-cfg-open');
          video?.pause?.();
          btn.focus({ preventScroll: true });
        }, { signal });
      }
    }

    #bindDrag() {
      this.#bindStageTools();
      const stage = this.querySelector('[data-ms-stage]');
      if (!stage) return;
      const { signal } = this.#controller;

      let dragging = false;
      let sx = 0;
      let sy = 0;
      let ox = 0;
      let oy = 0;

      stage.addEventListener('pointerdown', (e) => {
        if (!this.#geo) return;
        dragging = true;
        sx = e.clientX; sy = e.clientY;
        ox = this.#imgX; oy = this.#imgY;
        try { stage.setPointerCapture(e.pointerId); } catch { /* capture optionnelle */ }
        e.preventDefault();
      }, { signal });

      stage.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        if (!this.#userMoved) this.classList.add('msbb--dragged');
        this.#userMoved = true;
        this.#imgX = ox + (e.clientX - sx);
        this.#imgY = oy + (e.clientY - sy);
        this.#clampImg();
        this.#applyGeo();
      }, { signal });

      const end = () => { dragging = false; };
      stage.addEventListener('pointerup', end, { signal });
      stage.addEventListener('pointercancel', end, { signal });
    }

    /* ─── Barre collante ─── */

    #watchSticky() {
      if (!this.sticky) return;
      const anchor = this.cfgOpen || this.ctaSlot;
      if (!anchor || !('IntersectionObserver' in window)) return;

      const band = document.querySelector('.pfg__visu');
      const gate = document.querySelector('ms-avis-slider');
      let ctaVisible = true;
      let shown = null;
      let frame = 0;
      const update = () => {
        frame = 0;
        let covered = false;
        if (band && !band.hidden) {
          const r = band.getBoundingClientRect();
          covered = r.top < innerHeight && r.bottom > innerHeight - (this.sticky.offsetHeight || 76);
        }
        const reached = !gate || gate.getBoundingClientRect().top < innerHeight;
        const show = !ctaVisible && !covered && reached;
        if (show === shown) return;
        shown = show;
        this.#showSticky(show);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };

      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) ctaVisible = entry.isIntersecting;
        update();
      }, { threshold: 0 });

      observer.observe(anchor);
      const bandWatch = new MutationObserver(schedule);
      if (band || gate) window.addEventListener('scroll', schedule, { passive: true, signal: this.#controller.signal });
      if (band) bandWatch.observe(band, { attributes: true, attributeFilter: ['hidden'] });
      this.#controller.signal.addEventListener('abort', () => {
        observer.disconnect();
        bandWatch.disconnect();
        if (frame) cancelAnimationFrame(frame);
        this.#showSticky(false);
      });

      window.addEventListener('resize', () => { this.#reserveSpace(); schedule(); }, { signal: this.#controller.signal });
    }

    #showSticky(show) {
      this.sticky.classList.toggle('is-visible', show);
      this.sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      const cta = this.sticky.querySelector('[data-ms-sticky-cta]');
      if (cta) cta.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('ms-buybar-open', show);
      if (show) this.#reserveSpace();
    }

    /** La barre est fixée : sans réserve, elle masque la fin de page et le focus clavier. */
    #reserveSpace() {
      const h = this.sticky?.offsetHeight || 76;
      document.documentElement.style.setProperty('--ms-buybar-h', `${h}px`);
    }

    /** Prête à commander → on soumet. Sinon on amène le client au champ manquant. */
    #stickyAction() {
      if (this.cfgOpen) {
        this.#openConfig();
        return;
      }
      if (!this.incomplete) {
        this.#form?.requestSubmit(this.#atcBtn ?? undefined);
        return;
      }
      this.#focusMissing();
    }

    #focusMissing() {
      if (this.querySelector('[data-ms-zoom]')?.open && this.cfgOpen) this.#cfgShow('dims');
      const target = this.wInput?.value ? this.hInput : this.wInput;
      target?.scrollIntoView({ block: 'center', behavior: 'smooth' });
      target?.focus();
      return undefined;
    }

    /* ─── Panier ─── */

    /**
     * On reprend la soumission pour pouvoir envoyer plusieurs lignes d'un coup
     * (le décor, le kit de colle, la pose) — impossible avec le POST natif.
     */
    #onSubmit(event) {
      if (event.target !== this.#form) return;
      event.preventDefault();
      event.stopPropagation();

      if (this.blocked) {
        this.defEl?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      if (this.incomplete) return this.#focusMissing();

      const id = parseInt(this.#idInputs[0]?.value ?? '', 10);
      if (!Number.isFinite(id)) {
        window.alert("Choisissez un support avant d'ajouter au panier.");
        return;
      }

      const properties = {};
      for (const input of this.#form.querySelectorAll('input[name^="properties["]')) {
        if (input.disabled || !input.value) continue;
        properties[input.name.slice(11, -1)] = input.value;
      }
      const quantity = parseInt(this.#qtyInput?.value ?? '1', 10) || 1;

      if (this.dataset.exactEndpoint && this.#exactDims && !this.#exactPending) {
        this.#exactPending = true;
        this.#atcBtn?.setAttribute('aria-busy', 'true');
        clearTimeout(this.#prefetchTimer);
        const wait = this.#startWait();
        this.#exactFor(id).then(async (exactId) => {
          wait.step(1);
          try {
            if (exactId) {
              await this.#submitLine(exactId, 1, properties, wait);
            } else {
              properties['Surface facturée'] = `${quantity} m² (arrondi, calcul exact indisponible)`;
              this.#announce('Calcul exact momentanément indisponible : décor facturé au m² entamé.');
              await this.#submitLine(id, quantity, properties, wait);
            }
          } finally {
            this.#exactPending = false;
            this.#atcBtn?.removeAttribute('aria-busy');
            await wait.done();
          }
        });
        return;
      }
      this.#submitLine(id, quantity, properties);
    }

    #exactPending = false;
    /** Variantes créées à l'instant : Shopify peut encore les refuser une seconde ou deux. */
    #freshIds = new Set();
    /** @type {Map<string, Promise<number|null>>} */
    #exactCache = new Map();
    #prefetchTimer = 0;

    /** La variante exacte se prépare en silence 0,5 s après la dernière cote saisie :
     *  le temps que la cliente relise son récapitulatif, elle est prête. */
    #schedulePrefetch() {
      clearTimeout(this.#prefetchTimer);
      this.#prefetchTimer = setTimeout(() => this.#prefetch(), 500);
    }

    #prefetch() {
      const id = parseInt(this.#idInputs[0]?.value ?? '', 10);
      if (!Number.isFinite(id) || !this.#exactDims || this.blocked) return null;
      return this.#exactFor(id);
    }

    /** Une seule demande par décor, matière et dimensions. */
    #exactFor(baseId) {
      const d = this.#exactDims;
      const key = `${baseId}:${d.w}x${d.h}`;
      if (!this.#exactCache.has(key)) {
        const pending = this.#fetchExact(baseId, d).then((v) => {
          if (!v) this.#exactCache.delete(key);
          return v;
        });
        this.#exactCache.set(key, pending);
      }
      return this.#exactCache.get(key);
    }

    /**
     * Demande au service la variante au prix exact. Réponse en moins de 8 s,
     * sinon on rend la main au secours : la cliente peut toujours commander.
     * @param {number} baseId variante du support choisi
     * @returns {Promise<number|null>}
     */
    async #fetchExact(baseId, dims) {
      if (!dims) return null;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 6000);
      try {
        const endpoint = new URL('/variant', this.dataset.exactEndpoint);
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ product_id: Number(this.dataset.productId), variant_id: baseId, width_cm: dims.w, height_cm: dims.h }),
          signal: controller.signal,
        });
        const data = await response.json().catch(() => null);
        if (!response.ok || !data?.ok || !data.variant_id) return null;
        const exactId = Number(data.variant_id);
        if (data.reused) return exactId;
        this.#freshIds.add(exactId);
        await this.#waitVisible(exactId, Math.round(Number(data.price) * 100));
        return exactId;
      } catch (error) {
        console.error('Sur mesure :', error);
        return null;
      } finally {
        clearTimeout(timer);
      }
    }

    /**
     * L'attente se lit dans le bouton lui-même, comme partout ailleurs : un
     * indicateur et le mot de l'étape. Plus de voile sur la page, qui faisait
     * croire à un écran figé. Rien ne bouge si tout est prêt en moins de 150 ms.
     */
    #startWait() {
      const btn = this.#atcBtn;
      const steps = (this.dataset.waitSteps || '').split('|');
      let shown = false;
      const showTimer = setTimeout(() => {
        if (!btn) return;
        btn.dataset.busyLabel = steps[0] || '';
        btn.classList.add('msbb-busy');
        shown = true;
        if (steps[0]) this.#announce(steps[0]);
      }, 150);
      return {
        step: (n) => {
          if (btn && steps[n]) btn.dataset.busyLabel = steps[n];
        },
        done: async () => {
          clearTimeout(showTimer);
          if (!btn || !shown) return;
          btn.classList.remove('msbb-busy');
          delete btn.dataset.busyLabel;
        },
      };
    }

    /**
     * Une variante créée à l'instant peut être visible AVANT que son prix soit
     * diffusé : ajoutée trop tôt, elle part au panier à 0 € (vu le 28 oct. 2026).
     * On attend donc qu'elle soit en vente ET à son prix.
     * @param {number} variantId @param {number} [cents] prix attendu, en centimes @returns {Promise<boolean>}
     */
    async #waitVisible(variantId, cents = 0) {
      const handle = this.dataset.productHandle;
      if (!handle) return true;
      for (let i = 0; i < 12; i += 1) {
        await new Promise((resolve) => setTimeout(resolve, i === 0 ? 1800 : 900));
        try {
          const r = await fetch(`/products/${handle}.js?ms=${Date.now()}`, { headers: { Accept: 'application/json' } });
          const p = await r.json();
          if (p?.variants?.some((v) => v.id === variantId && v.available && (!cents || v.price === cents))) return true;
        } catch { /* on réessaie */ }
      }
      return false;
    }

    /**
     * Envoie au panier. Une variante créée à l'instant peut être refusée
     * (422) une seconde ou deux : on réessaie alors, quatre fois au plus.
     */
    async #post(url, init, retries) {
      let response = await fetch(url, init);
      while (response.status === 422 && retries > 0) {
        retries -= 1;
        await new Promise((resolve) => setTimeout(resolve, 900));
        response = await fetch(url, init);
      }
      return response;
    }

    /** Ajoute la ligne du décor (et ses suppléments), avec l'image du cadrage si possible. */
    #submitLine(id, quantity, properties, wait) {
      const retries = this.#freshIds.has(id) ? 4 : 0;
      const extras = [];
      const glueId = parseInt(this.dataset.glueId ?? '', 10);
      if (Number.isFinite(glueId) && this.#glueOn) extras.push({ id: glueId, quantity: 1 });
      const kit = this.querySelector('ms-pose-kit');
      if (kit && typeof kit.items === 'function') extras.push(...kit.items());

      return this.#renderCrop().then((blob) => {
        wait?.step(2);
        if (!blob) {
          return this.#addToCart([{ id, quantity, properties }, ...extras], this.#atcBtn, retries);
        }
        const fd = new FormData();
        fd.append('id', String(id));
        fd.append('quantity', String(quantity));
        for (const [key, value] of Object.entries(properties)) fd.append(`properties[${key}]`, value);
        const w = properties.Largeur ? properties.Largeur.replace(/\D/g, '') : '';
        const h = properties.Hauteur ? properties.Hauteur.replace(/\D/g, '') : '';
        const slug = (this.dataset.decorName || 'decor').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        fd.append('properties[Cadrage retenu]', new File([blob], `cadrage-${slug}-${w}x${h}.jpg`, { type: 'image/jpeg' }));
        return this.#addWithFile(fd, extras, this.#atcBtn, retries);
      });
    }

    /**
     * L'image du cadrage retenu, rendue depuis le fichier de l'aperçu à sa
     * résolution native, découpée aux mêmes proportions que le cadre.
     * @returns {Promise<Blob|null>}
     */
    #renderCrop() {
      return new Promise((resolve) => {
        const stageImg = this.querySelector('.msbb__stage-img');
        if (!stageImg || !this.#geo || !('HTMLCanvasElement' in window)) return resolve(null);
        const { fw, fh, iw, ih } = this.#geo;
        if (!iw || !ih) return resolve(null);
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          try {
            const natW = img.naturalWidth;
            const natH = img.naturalHeight;
            const sx = Math.max(0, (-this.#imgX / iw) * natW);
            const sy = Math.max(0, (-this.#imgY / ih) * natH);
            const sw = Math.min(natW - sx, (fw / iw) * natW);
            const sh = Math.min(natH - sy, (fh / ih) * natH);
            const outW = Math.min(1400, Math.round(sw));
            const outH = Math.round(outW * (sh / sw));
            const canvas = document.createElement('canvas');
            canvas.width = outW;
            canvas.height = outH;
            canvas.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, outW, outH);
            canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.86);
          } catch {
            resolve(null);
          }
        };
        img.onerror = () => resolve(null);
        img.src = stageImg.currentSrc || stageImg.src;
      });
    }

    /**
     * Le décor part avec son image de cadrage, en multipart : Shopify héberge
     * le fichier et l'inscrit dans la commande. /cart/add n'accepte pas
     * plusieurs articles ET un fichier dans la même requête : la colle et la
     * pose partent dans un second appel, juste après.
     * @param {FormData} fd
     * @param {Array<{id:number, quantity:number}>} extras
     * @param {HTMLButtonElement|null} button
     */
    async #addWithFile(fd, extras, button, retries = 0) {
      button?.classList.add('is-loading');
      if (button) button.disabled = true;
      const url = window.Theme?.routes?.cart_add_url ?? '/cart/add';
      const drawer = document.querySelector('cart-drawer');
      const sectionId = drawer?.dataset?.sectionId ?? undefined;
      if (sectionId) fd.append('sections', sectionId);

      try {
        const response = await this.#post(url, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
        }, retries);
        const raw = await response.text();
        let payload = null;
        try { payload = JSON.parse(raw); } catch { payload = null; }
        if (!response.ok || !payload) {
          window.alert(payload?.description ?? payload?.message ?? "Ajout au panier impossible. Réessayez.");
          return;
        }
        let added = parseInt(fd.get('quantity'), 10) || 1;
        if (extras.length) {
          const second = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: extras, sections: sectionId }),
          });
          const secondRaw = await second.text();
          try {
            const secondPayload = JSON.parse(secondRaw);
            if (second.ok && secondPayload?.sections) payload.sections = secondPayload.sections;
            if (second.ok) added += extras.reduce((sum, item) => sum + item.quantity, 0);
          } catch { /* les options sont facultatives : le décor est déjà au panier */ }
        }
        const posed = await this.#syncPose(sectionId);
        if (posed?.sections) payload.sections = posed.sections;
        this.#afterAdd(payload, added, posed?.itemCount);
      } catch (error) {
        window.alert(`Erreur d'ajout au panier : ${error?.message ?? 'réseau indisponible'}`);
      } finally {
        button?.classList.remove('is-loading');
        if (button) button.disabled = false;
      }
    }

    /**
     * Le montant de la pose pour la surface du mur, dans la carte et le
     * récapitulatif. Au-delà du plafond, la carte cède la place au devis.
     * @param {number} billed - m² facturés du décor
     */
    #renderPose(billed) {
      const card = this.querySelector('[data-ms-pose-card]');
      if (!card || !window.MsPose) return null;
      const q = window.MsPose.quote(this.#touched ? billed : 0);
      const over = q.state === 'over';
      card.hidden = over;
      const more = this.querySelector('[data-ms-pose-more]');
      if (more) more.hidden = over;
      const overNote = this.querySelector('[data-ms-pose-over]');
      if (overNote) overNote.hidden = !over;
      if (over) {
        const input = this.querySelector('[data-ms-install]');
        if (input) input.checked = false;
      }
      const label = q.state === 'ok' ? `+ ${window.MsPose.money(q.price)} pour ${q.m2} m²` : '';
      this.#setText('[data-ms-pose-price]', label);
      this.#setText('[data-ms-recap-install-price]', q.state === 'ok' ? `+ ${window.MsPose.money(q.price)}` : '');
      return q;
    }

    /**
     * Met la ligne « La Pose » d'accord avec les décors du panier, juste
     * après un ajout. Cochée, la pose est demandée ; sinon, elle suit ce qui
     * est déjà au panier. Une surface totale au-delà du plafond est signalée.
     * @param {string|undefined} sectionId
     */
    async #syncPose(sectionId) {
      if (!window.MsPose) return null;
      try {
        const result = await window.MsPose.sync({ want: this.#installOn ? true : undefined, sections: sectionId ?? null });
        const overNote = this.querySelector('[data-ms-pose-over]');
        if (this.#installOn && result.quote.state === 'over' && overNote) overNote.hidden = false;
        return result;
      } catch {
        return null;
      }
    }

    /** L'article EST au panier : on ouvre le tiroir, ou on y emmène la cliente. */
    #afterAdd(payload, added, total) {
      const cfg = this.querySelector('[data-ms-zoom]');
      if (cfg?.open) cfg.close();
      try {
        const icon = document.querySelector('cart-icon');
        const current = Number.isFinite(total) ? total - added : (typeof icon?.getCurrentItemCount === 'function' ? icon.getCurrentItemCount() : null);
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            resource: {},
            data: {
              itemCount: Number.isFinite(current) ? current + added : undefined,
              source: 'ms-buybox',
              sections: payload.sections,
            },
          },
        }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      } catch {
        window.location.href = window.Theme?.routes?.cart_url ?? '/cart';
      }
    }

    /**
     * L'Échantillon A4, ajouté au panier sans quitter la page ni toucher au
     * décor en cours de configuration. C'est un produit distinct, sans image
     * ni titre propres au décor : les deux propriétés de décor sont
     * indispensables, sinon le panier affiche un article générique et la
     * cliente ne sait plus lequel elle a demandé.
     * @param {HTMLElement} button
     */
    #addSample(button) {
      const matiere = this.dataset.sampleMatiere === '1';
      const own = matiere
        ? this.querySelector('[data-ms-sample-support]:checked') ?? this.querySelector('[data-ms-sample-support]')
        : null;
      const picked = own ?? this.querySelector('[data-ms-support]:checked');
      const grand = !own && this.querySelector('[data-ms-sample-format]:checked')?.value === 'grand';
      const id = parseInt((own ? own.value : grand ? picked?.dataset.sampleGrandId : picked?.dataset.sampleId) ?? '', 10);
      if (!Number.isFinite(id)) return;
      const properties = matiere ? {} : this.#decorProps();
      if (picked?.dataset.name) properties.Support = picked.dataset.name;
      const format = grand ? this.dataset.sampleGrandFormat : this.dataset.sampleFormat;
      if (format) properties.Format = format;
      this.#addToCart([{ id, quantity: 1, properties }], button);
    }

    /** Le format choisi : le prix de la pastille et la forme de la feuille suivent. */
    #showSampleFormat() {
      const input = this.querySelector('[data-ms-sample-format]:checked');
      if (!input) return;
      const grand = input.value === 'grand';
      const price = this.querySelector('[data-ms-sample-price]');
      if (price && input.dataset.price) price.textContent = input.dataset.price;
      this.querySelector('[data-ms-sample-sheet]')?.classList.toggle('msbb__sheet--a4', !grand);
      const tag = this.querySelector('[data-ms-sample-tag]');
      if (tag) tag.textContent = (grand ? tag.dataset.tagGrand : tag.dataset.tagA4) || tag.textContent;
    }

    /**
     * Identité du décor, portée par la ligne de panier.
     * « _Aperçu » commence par un souligné : Shopify masque alors la propriété
     * au client (une URL n'a rien à faire dans un panier) tout en la laissant
     * lisible par le thème, qui s'en sert comme vignette.
     */
    #decorProps() {
      const props = {};
      if (this.dataset.decorName) props['Décor'] = this.dataset.decorName;
      if (this.dataset.decorThumb) props._Aperçu = this.dataset.decorThumb;
      return props;
    }

    async #addToCart(items, button, retries = 0) {
      button?.classList.add('is-loading');
      if (button) button.disabled = true;

      const drawer = document.querySelector('cart-drawer');
      const sectionId = drawer?.dataset?.sectionId ?? undefined;

      try {
        const response = await this.#post(window.Theme?.routes?.cart_add_url ?? '/cart/add', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items, sections: sectionId }),
        }, retries);

        const raw = await response.text();
        let payload = null;
        try { payload = JSON.parse(raw); } catch { payload = null; }

        if (!response.ok || !payload) {
          window.alert(payload?.description ?? payload?.message ?? "Ajout au panier impossible. Réessayez.");
          return;
        }

        const posed = await this.#syncPose(sectionId);
        if (posed?.sections) payload.sections = posed.sections;
        this.#afterAdd(payload, items.reduce((sum, item) => sum + item.quantity, 0), posed?.itemCount);
      } catch (error) {
        window.alert(`Erreur d'ajout au panier : ${error?.message ?? 'réseau indisponible'}`);
      } finally {
        button?.classList.remove('is-loading');
        if (button) button.disabled = false;
      }
    }
  }

  if (!customElements.get('ms-buybox')) customElements.define('ms-buybox', MsBuybox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ms-ugc"] && !Shopify.designMode) return;
  try {
    /**
   * Témoignages vidéo. La lecture est toujours déclenchée par la cliente :
   * l'affiche seule est chargée tant qu'elle n'a pas cliqué (preload="none").
   */
  class MsUgc extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;
      for (const button of this.querySelectorAll('[data-ms-ugc-play]')) {
        button.addEventListener('click', () => this.#play(button), { signal });
      }
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    #play(button) {
      const video = button.parentElement?.querySelector('[data-ms-ugc-video]');
      if (!video) return;

      // Une seule vidéo à la fois : deux témoignages qui parlent ensemble
      // ne s'entendent ni l'un ni l'autre.
      for (const other of this.querySelectorAll('[data-ms-ugc-video]')) {
        if (other === video) continue;
        other.pause();
        other.parentElement?.querySelector('[data-ms-ugc-play]')?.removeAttribute('hidden');
      }

      button.hidden = true;
      video.controls = true;
      video.play().catch(() => {
        // Lecture refusée par le navigateur : on rend la main plutôt que
        // de laisser une affiche muette sans bouton.
        button.hidden = false;
        video.controls = false;
      });
    }
  }

  if (!customElements.get('ms-ugc')) customElements.define('ms-ugc', MsUgc);
  } catch(e) { console.error(e); }
})();

})();
